import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { SessionPublicAPIsForStartFlowApi } from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitNextPage = createAsyncThunk<void, void, ThunkApi>(
  "submitNextPage",
  async (_, { rejectWithValue }) => {
    try {
      await new SessionPublicAPIsForStartFlowApi().next();
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Prossima pagina",
        description: "Non siamo riusciti a caricare la pagina successiva",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
